export const environment = {
    production: false,
    local: false,
    WS_URL: 'https://dev-exp.royalny.net',
    RMS_URL: 'https://dev-rms-ng.royalny.net',
    featureFlag: true,
    AZ_CLIENT_ID: "66f7dbae-faf5-40cc-b51b-0e973635921a",
    AZ_TENANT_ID: "e875b9bb-b3ee-4961-b756-3aad14e43814",
    DD_APP_ID: '0f1317f4-c4c7-447f-9fa1-641db77eced5',
    DD_CLIENT_TOKEN: 'pubbdd651e87df4c3850cbaec15d27aa992'
};
